/**
 * Same-origin API helpers (match xs-template-web-app).
 * Prefer /api via Vite proxy over absolute API_BASE_URL for auth cookies / CSRF.
 */
import { getAuthHeaders } from "@xinosolutions/xs-auth-react";

export function apiUrl(path) {
  const p = path.startsWith("/") ? path : `/${path}`;
  return p.startsWith("/api") ? p : `/api${p}`;
}

const CSRF_HEADER = "X-CSRF-Token";

export async function fetchJson(path, options = {}) {
  const url = apiUrl(path);
  const headers = {
    "Content-Type": "application/json",
    ...getAuthHeaders(),
    ...(options.headers || {}),
  };
  const res = await fetch(url, {
    ...options,
    headers,
    credentials: "include",
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.message || res.statusText || "Request failed");
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export async function fetchCsrfToken() {
  const data = await fetchJson("/api/general_routes/csrf_token", {
    method: "GET",
  });
  return data.csrf_token || data.csrfToken;
}

export async function postJsonWithCsrf(path, body) {
  const csrf = await fetchCsrfToken();
  return fetchJson(path, {
    method: "POST",
    body: JSON.stringify(body || {}),
    headers: { [CSRF_HEADER]: csrf },
  });
}

/** Clears product session cookies (best-effort; XS Auth logout is primary). */
export async function postLogoutAssociate() {
  try {
    return await postJsonWithCsrf("/api/member_logout", {});
  } catch {
    return null;
  }
}
